import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import auth from "./store/auth/";
import settings from "./store/settings/";
import users from "./store/users/";
import general from "./store/general/";
import associations from "./store/associations/";
import events from "./store/events/";
import competitions from "./store/competitions/";
import divisions from "./store/divisions/";
import disciplines from "./store/disciplines/";
import stats from "./store/stats/";
import eventsEntries from "./store/eventsEntries/";
import questions from "./store/questions/";
import questionTypes from "./store/questionTypes";
import dqCodes from "./store/dqCodes";
import awards from "./store/awards";
import eventProgress from "./store/eventProgress/";
import pointsTable from "./store/pointsTable/";
import competitionInvoiceSettings from "./store/competitionInvoiceSettings/";
import xeroSettings from "./store/xeroSettings/";
import reports from "./store/reports/";
import liveResults from "./store/liveResults/";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    settings,
    users,
    general,
    associations,
    events,
    competitions,
    divisions,
    disciplines,
    stats,
    eventsEntries,
    questions,
    questionTypes,
    dqCodes,
    awards,
    eventProgress,
    pointsTable,
    competitionInvoiceSettings,
    xeroSettings,
    reports,
    liveResults
  },
  plugins: [
    createPersistedState({
      paths: ["auth", "settings", "users", "general", "pointsTable"]
    })
  ]
});
